<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span>For Jon, who still makes me laugh. Sometimes intentionally.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?5812c96c